<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filters" ref="filters">
          <el-form-item prop="time">
            <el-date-picker v-model="filters.time" type="year" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportExcel" :loading="excelLoading">文件导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('filters')">重置</el-button>
          </el-form-item>

        </el-form>
      </el-col>
      <el-alert title="提示：如不指定日期，默认查询当年的数据" type="success"></el-alert>
      <el-table :data="goods" v-loading="loading" style="width: 100%" :highlight-current-row="false" :row-class-name="tableRowClassName" border>
        <el-table-column prop="no" label="货号"></el-table-column>
        <el-table-column prop="type" label="分类"></el-table-column>
        <el-table-column prop="one" label="1月"></el-table-column>
        <el-table-column prop="two" label="2月"></el-table-column>
        <el-table-column prop="three" label="3月"></el-table-column>
        <el-table-column prop="four" label="4月"></el-table-column>
        <el-table-column prop="five" label="5月"></el-table-column>
        <el-table-column prop="six" label="6月"></el-table-column>
        <el-table-column prop="seven" label="7月"></el-table-column>
        <el-table-column prop="eight" label="8月"></el-table-column>
        <el-table-column prop="nine" label="9月"></el-table-column>
        <el-table-column prop="ten" label="10月"></el-table-column>
        <el-table-column prop="eleven" label="11月"></el-table-column>
        <el-table-column prop="twelve" label="12月"></el-table-column>
      </el-table>
    </el-col>
  </el-row>
</template>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
<script>
import API from "@/api/frsendgoodsapi/fivesale.js";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      excelLoading: false,
      filters: { time: null },
      goods: [],
    };
  },
  methods: {
    exportExcel() {
      const yearValue = this.filters.time ? moment(this.filters.time).year() : null;
      const params = { year: yearValue };
      // 定义动态文件名
      const fileName = `新品销售统计.xlsx`;
      API.exportExcel(params)
        .then((res) => {
          if (res) {
            this.excelLoading = true;
            const content = res;
            const blob = new Blob([content]);
            if (typeof navigator.msSaveBlob !== "undefined") {
              // 兼容IE
              navigator.msSaveBlob(blob, fileName);
            } else {
              // 其他浏览器
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              link.download = fileName; // 设置文件名
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href);
              document.body.removeChild(link);
            }
            this.excelLoading = false;
          }
        })
        .catch((error) => {
          this.excelLoading = false;
          this.$message.error("Excel文件导出失败");
          console.error("Excel文件导出失败：", error);
        });
    },
    //修改某行的颜色
    tableRowClassName({ row, rowIndex }) {
      if (row.type.length === 0) {
        return "custom-row-class";
      }
    },

    handleSearch() {
      this.search();
    },

    search() {
      this.loading = true;
      const yearValue = this.filters.time ? moment(this.filters.time).year() : null;
      const params = { year: yearValue };
      API.list(params)
        .then(
          (result) => {
            this.loading = false;
            this.goods = result.data;
          },
          (err) => {
            this.loading = false;
            this.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          this.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$nextTick(() => {});
    },
  },

  mounted() {
    this.handleSearch();
  },
};
</script>

<style>
.el-table .warning-row {
  font-weight: 500;
  background: green;
}

.el-table .custom-row-class {
  font-weight: 1000;
  background: #d08fd0;
}

.el-table__body tr:hover {
  background-color: inherit !important;
}
</style>
